import { Calendar, Popover } from '@medly-components/core';
import type { FC } from 'react';
import ClearButton from './ClearButton';
import DatePickerButton from './DatePickerButton';
import { FlatDatePickerProps } from './types';

export const FlatDatePicker: FC<FlatDatePickerProps> = ({ value, onChange, showClearIcon }) => {
    return (
        <Popover interactionType="click">
            <DatePickerButton />
            <Popover.Popup placement="bottom-end" distance="1rem">
                <Calendar
                    id="calendar"
                    date={value}
                    onChange={onChange}
                    minSelectableDate={new Date(1901, 0, 1)}
                    maxSelectableDate={new Date(2100, 11, 1)}
                >
                    {showClearIcon && <ClearButton onClick={() => onChange(null)}>Clear</ClearButton>}
                </Calendar>
            </Popover.Popup>
        </Popover>
    );
};

FlatDatePicker.displayName = 'FlatDatePicker';
